import type { ContentBlock } from "../../blockTypes";
import BlockRenderer from "./BlockRenderer";

interface BlockListProps {
    blocks?: ContentBlock[];
    onComplete?: () => void; // Called when a question inside is answered correctly
}

// A vertical list of blocks: instructions, hints, feedback and explanations all use it
const BlockList = ({ blocks = [], onComplete }: BlockListProps) => {
    return (
        <div className="flex flex-col gap-3">
            {blocks.map((block, index) => (
                <BlockRenderer key={block.id ?? index} block={block} onComplete={onComplete} />
            ))}
        </div>
    );
};

export default BlockList;